"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reduceLength = exports.mapErrors = exports.isValidInternalLink = exports.isValidExternalLink = exports.getResourceLink = exports.getBorderColor = exports.foldersToTree = void 0;
var _cccisdColorPicker = require("cccisd-color-picker");
var _color = _interopRequireDefault(require("color"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var reduceLength = exports.reduceLength = function reduceLength(str) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 14;
  if (str.length <= length) {
    return str;
  }
  var arr = str.split('.');
  var extension = arr.length > 1 ? '.' + arr.pop() : '';
  var name = arr.join('');
  var lengthRest = length - extension.length - 1;
  var firstPart = Math.ceil(lengthRest / 2);
  var lastPart = Math.floor(lengthRest / 2);
  return name.slice(0, firstPart) + '…' + name.slice(-lastPart) + extension;
};
var mapErrors = exports.mapErrors = function mapErrors() {
  var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mapKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var keys = Object.keys(errors);
  var result = {};
  keys.forEach(function (key) {
    var value = typeof errors[key] === 'string' ? errors[key] : errors[key].join('\n');
    key = mapKeys[key] || key;
    if (!result[key]) {
      result[key] = value;
    } else {
      result[key] += '\n' + value;
    }
  });
  return result;
};
var foldersToTree = exports.foldersToTree = function foldersToTree(folders) {
  var result = [];
  var _populateBranch = function populateBranch(branch, tree) {
    var leaf = branch.shift();
    var node = tree.find(function (item) {
      return item.name === leaf;
    });
    if (!node) {
      node = {
        name: leaf,
        children: []
      };
      tree.push(node);
    }
    if (branch.length > 0) {
      _populateBranch(branch, node.children);
    }
  };
  folders.map(function (folder) {
    return folder.replace(/^\//, '').split('/');
  }).forEach(function (arr) {
    return _populateBranch(arr, result);
  });
  return result;
};
var isValidExternalLink = exports.isValidExternalLink = function isValidExternalLink(link) {
  var regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&%'()*+,;=.]+$/;
  return regex.test(link);
};
var isValidInternalLink = exports.isValidInternalLink = function isValidInternalLink(link) {
  var regex = /^\/([^/].+)?$/;
  return regex.test(link);
};
var getBorderColor = exports.getBorderColor = function getBorderColor(colorStr) {
  return (0, _color["default"])((0, _cccisdColorPicker.getColor)(colorStr)).lightness(95);
};
var getResourceLink = exports.getResourceLink = function getResourceLink(resource) {
  var _metadata$link;
  var metadata = resource.published_metadata || {};
  var url = '';
  switch (resource.type) {
    case 'course':
      {
        var courseData = resource.courseData;
        var respondentHash = (0, _get2["default"])(courseData, 'settings.requireLogin') || Fortress.user.acting.role.handle === 'guest' || courseData.type === 'anon' ? '' : "/".concat(Fortress.user.acting.respondent_hash);
        if (metadata.courseCustomUrl) {
          if (isValidInternalLink(metadata.courseCustomUrl)) {
            url = Boilerplate.url(metadata.courseCustomUrl);
            break;
          }
          url = metadata.courseCustomUrl;
          break;
        }
        url = Boilerplate.url("/d/".concat(courseData.hash).concat(respondentHash));
        break;
      }
    case 'document':
      {
        // Replace cccisd-public CloudFront domain name (dm0gz550769cd.cloudfront.net)
        // with its alternate, human-readable domain name
        if (resource.published_url) {
          var path = resource.published_url.split('/').slice(3).join('/');
          var filenameParam = resource.published_label ? "?filename=".concat(resource.published_label) : '';
          url = "https://public.3c-cdn.com/".concat(path).concat(filenameParam);
        }
        break;
      }
    case 'link':
      url = (_metadata$link = metadata.link) !== null && _metadata$link !== void 0 ? _metadata$link : url;
      break;
    case 'video':
      {
        // Get URL from embed code ie. <iframe src="URL">
        var srcRegex = /src="([^"]*)"/;
        var match = srcRegex.exec(metadata.embed);
        url = match ? match[1] : url;
        break;
      }
    default:
      break;
  }
  return url;
};